<div class="container my-3">
    <div class="row m-0 px-2">
        <div class="col-auto">
            <div [ngClass]="{'font-weight-bold': true}">{{'CourtEventDetails.Timeline' | translate}}</div>
        </div>
        <div class="col-auto"></div>
    </div>
    <div class="row mt-1">
        <div class="col">
            <div *ngFor="let timeline of timelines; let i = index; let first = first; let last = last">
                <div class="row m-0 pl-0 py-1 pr-0 align-items-center"
                    [ngClass]="{'bay-club-light-blue-2-bg': (i + 1) % 2 === 0}">
                    <div class="col-2">
                        <div class="row">
                            <div class="col px-0 text-right">
                                <div *ngIf="!first && !last" [ngClass]="{'grey': true}">
                                    {{ timeline.createdAt| bcDateTime: 'MMM DD'}} &#64;
                                    {{ timeline.createdAt | bcDateTime: 'h:mm A' }}
                                </div>
                                <div *ngIf="first || last">
                                    {{ timeline.createdAt| bcDateTime: 'MMM DD, YYYY'}} &#64;
                                    {{ timeline.createdAt | bcDateTime: 'h:mm A' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-1">
                        <div class="row no-gutters py-0 my-0 align-items-center justify-content-center">
                            <div class="col-auto">
                                <span class="ic-timeline" *ngIf="!first"></span>
                                <div *ngIf="first">&nbsp;</div>
                            </div>
                            <div class="w-100"></div>
                            <div class="col-auto">
                                <span class="ic-timeline-dot"></span>
                            </div>
                            <div class="w-100"></div>
                            <div class="col-auto">
                                <span class="ic-timeline" *ngIf="!last"></span>
                                <div *ngIf="last">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-1">
                        <app-court-event-status-pill [timelinePanel]="true"
                            [status]="timeline.playerStatus ? timeline.playerStatus : timeline.eventStatus"></app-court-event-status-pill>
                    </div>
                    <div class="col-4">
                        {{ getDescription(timeline) }}
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </div>
</div>